import { QueryKey, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useInvalidateQuery = () => {
  const queryClient = useQueryClient();

  const invalidateQueries = useCallback(
    async (queryKeys: QueryKey) => {
      await Promise.all(queryKeys.map((key) => queryClient.invalidateQueries({ queryKey: [key], refetchType: 'all' })));
    },
    [queryClient]
  );

  return invalidateQueries;
};
